import { combineReducers } from 'redux';
import userReducer from './userSlice';
import userAssetsReducer from './slices/userAssetsSlice';
import groupsReducer from './slices/groupsSlice';
const rootReducer = combineReducers({
  user: userReducer,
  userAssets: userAssetsReducer,
  groups: groupsReducer,
});

export default rootReducer;
